import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.concat.js";
import { BaseTransformer } from './BaseTransformer';
export var participantTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(participantTransformer, _BaseTransformer);
  var _super = _createSuper(participantTransformer);
  function participantTransformer() {
    _classCallCheck(this, participantTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(participantTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        target_record_id: data.record_id,
        target_name: "".concat(data.firstname, " ").concat(data.lastname),
        target_app_id: 'crm',
        target_model_id: 'contact',
        target_email: data.email
      };
    }
  }]);
  return participantTransformer;
}(BaseTransformer);